import React, { useEffect } from 'react'
import AopsCommonModalLayout from '../modal/AopsCommonModalLayout'
import EmojiDropDown from '../EmojiDropDown'
// import './fastLaneModal.scss'

import { CalendarFilled } from '@ant-design/icons'
import { Checkbox, DatePicker, Input, message, Select, Typography } from 'antd'
import dayjs from 'dayjs'
import { useState } from 'react'
import { useRecoilState } from 'recoil'
import Swal from 'sweetalert2'
import {
  createFastLane,
  deleteFastResponseWork,
  updateFastLane,
} from '../../../api/aopsFastLane.api'
import {
  createFastlaneCheckList,
  deleteFastlaneCheckList,
  switchFastlaneCheckList,
  updateFastlaneCheckListTitle,
} from '../../../api/aops.api'
import { userState } from '../../../store/user'
const { Text } = Typography
// const { TextArea } = Input

// FormSection 컴포넌트를 FastLaneModal 외부로 이동하여 리렌더링 시 포커스 손실 방지
const FormSection = ({ label, children }) => (
  <div className="form-section">
    <label className="form-label">{label}</label>
    <div style={{ flex: 1, minWidth: 0 }}>{children}</div>
  </div>
)

const FastLaneModal = ({
  open = false,
  onClose,
  title,
  fastLaneDetail = null,
  fetchFastLaneList = () => {},
  onReloadInitData = () => {},
}) => {
  const [user] = useRecoilState(userState)
  const [formData, setFormData] = useState({
    title: '',
    date: null,
    hour: '09',
    minute: '30',
    emojiText: '✨',
    checkList: [], // { id, title, isChecked }
  })
  const [tempSubTask, setTempSubTask] = useState('')
  const [editingId, setEditingId] = useState(null)
  // 체크리스트 변경 추적 (Diff Logic)
  const [originalCheckList, setOriginalCheckList] = useState([])
  const [deletedCheckListIds, setDeletedCheckListIds] = useState([])
  // console.log('fastLaneDetail = ', fastLaneDetail)
  // 상세 조회 시 API 응답(emojiText 포함)을 폼 초기값으로 반영
  // open이 true이고 fastLaneDetail이 있을 때만 실행 (입력 중 리렌더링 방지)
  useEffect(() => {
    if (open && fastLaneDetail) {
      const dueDateSource =
        fastLaneDetail?.dueDate || fastLaneDetail?.dueDateTime
      // 백엔드 응답: GetFastlaneWorkDetailResponse의 checkList 필드 사용
      const fetchedCheckList = fastLaneDetail?.checkList || []
      setFormData({
        title: fastLaneDetail?.title || '',
        date: dueDateSource ? dayjs(dueDateSource) : null,
        hour: dueDateSource ? dayjs(dueDateSource).format('HH') : '09',
        minute: dueDateSource ? dayjs(dueDateSource).format('mm') : '30',
        emojiText:
          fastLaneDetail?.emojiText !== undefined &&
          fastLaneDetail?.emojiText !== null &&
          fastLaneDetail.emojiText !== ''
            ? fastLaneDetail.emojiText
            : '✨',
        checkList: fetchedCheckList.map((item) => ({
          id: item.id,
          title: item.title,
          isChecked: item.isChecked,
        })),
      })
      // 변경 사항 비교를 위한 원본 저장 (동기화 로직용)
      setOriginalCheckList(JSON.parse(JSON.stringify(fetchedCheckList)))
    }
  }, [fastLaneDetail?.id, open]) // fastLaneDetail.id만 의존성으로 사용하여 불필요한 리렌더링 방지
  const hours = Array.from({ length: 24 }, (_, idx) =>
    String(idx).padStart(2, '0'),
  )
  const minutes = Array.from({ length: 6 }, (_, idx) =>
    String(idx * 10).padStart(2, '0'),
  )

  const resetForm = () => {
    setFormData({
      title: '',
      date: null,
      hour: '09',
      minute: '30',
      emojiText: '✨',
      checkList: [],
    })
    setTempSubTask('')
    setEditingId(null)
    setOriginalCheckList([])
    setDeletedCheckListIds([])
    onClose()
  }

  useEffect(() => {
    if (!open) {
      resetForm()
    } else if (open) {
      // 모달이 열릴 때 삭제 목록 초기화
      setDeletedCheckListIds([])
    }
    // open이 true일 때는 tempSubTask를 초기화하지 않음 (BoardWorkPopup 방식)
  }, [open])

  const openErrorModal = (error) => {
    let errorMessage = '오류가 발생했습니다.'
    if (error?.response?.data) {
      if (
        error.response.data.detail &&
        Array.isArray(error.response.data.detail)
      ) {
        errorMessage =
          error.response.data.detail[1]?.description ||
          error.response.data.detail[0]?.description ||
          error.response.data.message ||
          errorMessage
      } else if (error.response.data.message) {
        errorMessage = error.response.data.message
      } else if (error.response.data.detail) {
        errorMessage =
          typeof error.response.data.detail === 'string'
            ? error.response.data.detail
            : errorMessage
      }
    } else if (error?.message) {
      errorMessage = error.message
    }
    Swal.fire({
      customClass: { popup: 'custom-alert' },
      icon: 'error',
      title: '에러 발생',
      text: errorMessage,
    })
  }

  const validateForm = () => {
    if (!formData.title) return false
    if (!formData.date) return false
    if (!formData.hour) return false
    if (!formData.minute) return false
    return true
  }

  const handleSubmit = async () => {
    if (!validateForm()) {
      message.error('모든 필드를 입력해주세요')
      return
    }
    const isEditMode = !!fastLaneDetail
    const dueDateString =
      formData.date.format('YYYY-MM-DD') +
      ' ' +
      formData.hour +
      ':' +
      formData.minute +
      ':00'

    try {
      let currentFastLaneWorkId = fastLaneDetail?.id
      if (isEditMode) {
        const updatePayload = {
          workId: fastLaneDetail?.id,
          title: formData.title,
          dueDate: dueDateString,
          isComplete: fastLaneDetail?.isComplete,
          emojiText: formData.emojiText ?? '',
        }
        await updateFastLane(updatePayload)
        message.success('패스트 업무가 수정되었습니다.')
      } else {
        const createPayload = {
          title: formData.title,
          dueDate: dueDateString,
          salusUserId: user.id,
          emojiText: formData.emojiText ?? '',
        }
        const res = await createFastLane(createPayload)
        console.log('createFastLane 응답:', res)
        // 응답에서 ID 추출 (다양한 응답 구조 대응)
        // 백엔드 응답이 숫자일 수도 있고 객체일 수도 있음
        if (typeof res === 'number') {
          currentFastLaneWorkId = res
        } else {
          currentFastLaneWorkId =
            res?.id ||
            res?.workId ||
            res?.data?.id ||
            res?.data?.workId ||
            (typeof res === 'object' && Object.keys(res).length === 0
              ? null
              : res)
        }
        if (!currentFastLaneWorkId) {
          console.error('FastLane 생성 응답에서 ID를 찾을 수 없습니다:', res)
          message.error('업무 생성은 완료되었지만 ID를 확인할 수 없습니다.')
          // ID가 없으면 체크리스트 동기화를 건너뛰고 종료
          fetchFastLaneList()
          onReloadInitData()
          resetForm()
          return
        }
        message.success('패스트 업무가 생성되었습니다.')
      }

      // 체크리스트 동기화 수행 (ID가 유효한 경우에만)
      if (currentFastLaneWorkId) {
        await syncCheckList(currentFastLaneWorkId)
      }

      fetchFastLaneList()
      onReloadInitData()
      resetForm()
    } catch (error) {
      console.log(error)
      openErrorModal(error)
    }
  }

  const handleDelete = async () => {
    try {
      await deleteFastResponseWork(fastLaneDetail?.id)
      message.success('패스트 업무가 삭제되었습니다.')
      resetForm()
      fetchFastLaneList()
      onReloadInitData()
    } catch (error) {
      console.log(error)
      openErrorModal(error)
    }
  }

  // 하위업무 관련 핸들러 (BoardWorkPopup 방식)
  const handleInputSubmit = () => {
    if (tempSubTask.trim()) {
      addSubTask()
    }
  }

  const addSubTask = () => {
    if (!tempSubTask.trim()) {
      message.warning('내용을 입력해주세요.')
      return
    }
    const taskTitle = tempSubTask.trim()
    const newItem = {
      id: `new-${Date.now()}`,
      title: taskTitle,
      isChecked: false,
    }
    // React의 배치 업데이트를 활용하여 한 번에 처리
    setFormData((prev) => ({
      ...prev,
      checkList: [...prev.checkList, newItem],
    }))
    // tempSubTask는 즉시 초기화 (BoardWorkPopup과 동일)
    setTempSubTask('')
  }

  const removeSubTask = (targetId) => {
    // 서버에 이미 저장된 데이터인 경우 삭제 목록에 추가
    if (
      typeof targetId === 'number' ||
      !targetId.toString().startsWith('new-')
    ) {
      setDeletedCheckListIds((prev) => [...prev, targetId])
    }
    setFormData((prev) => ({
      ...prev,
      checkList: prev.checkList.filter((item) => item.id !== targetId),
    }))
  }

  const toggleCheckItem = (id) => {
    setFormData((prev) => ({
      ...prev,
      checkList: prev.checkList.map((item) =>
        item.id === id ? { ...item, isChecked: !item.isChecked } : item,
      ),
    }))
  }

  const handleTitleChange = (id, newTitle) => {
    setFormData((prev) => ({
      ...prev,
      checkList: prev.checkList.map((item) =>
        item.id === id ? { ...item, title: newTitle } : item,
      ),
    }))
  }

  /** 체크리스트 동기화 로직 (BoardWorkPopup 방식) */
  const syncCheckList = async (fastLaneWorkId) => {
    // 1. 삭제 처리는 순서와 상관없으므로 병렬 처리해도 무방합니다.
    const deletePromises = deletedCheckListIds
      .filter((cid) => typeof cid === 'number')
      .map((cid) => deleteFastlaneCheckList(cid))
    await Promise.all(deletePromises)

    // 2. 생성 및 수정은 리스트의 순서대로 '순차적'으로 실행합니다.
    // for...of 루프 내에서 await를 사용하면 이전 항목 처리가 끝난 후 다음 항목으로 넘어갑니다.
    for (const item of formData.checkList) {
      const isNew = item.id.toString().startsWith('new-')

      if (isNew) {
        // 순차 생성: DB에 순서대로 INSERT 되도록 보장
        await createFastlaneCheckList({
          workId: fastLaneWorkId,
          title: item.title,
        })
      } else {
        const original = originalCheckList.find((o) => o.id === item.id)
        if (original) {
          if (original.title !== item.title) {
            await updateFastlaneCheckListTitle(item.id, item.title)
          }
          if (original.isChecked !== item.isChecked) {
            await switchFastlaneCheckList(item.id)
          }
        }
      }
    }
  }

  return (
    <AopsCommonModalLayout open={open} onClose={onClose} title={title}>
      <div className="form-container">
        <div className="form-wrapper">
          <div className="form-section">
            <label className="form-label">
              업무 명 <span style={{ color: 'red' }}>*</span>
            </label>
            <div style={{ width: '100%' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  width: '100%',
                }}
              >
                <EmojiDropDown
                  value={formData.emojiText}
                  defaultValue={
                    fastLaneDetail?.emojiText !== undefined &&
                    fastLaneDetail?.emojiText !== null &&
                    fastLaneDetail.emojiText !== ''
                      ? fastLaneDetail.emojiText
                      : '✨'
                  }
                  onChange={(data) =>
                    setFormData({
                      ...formData,
                      emojiText:
                        typeof data === 'string' ? data : (data?.emoji ?? ''),
                    })
                  }
                />
                <Input
                  placeholder="생성할 체크리스트 업무의 이름을 입력해주세요"
                  value={formData.title}
                  onChange={(e) => {
                    if (e.target.value.length > 50) return
                    setFormData({ ...formData, title: e.target.value })
                  }}
                  className="form-input"
                  style={{ flex: 1, minWidth: 0 }}
                />
              </div>
              <div className="example-text-group">
                <Text className="example-text">패스트 업무란?</Text>
                <Text
                  className="example-text"
                  style={{
                    fontSize: '12px',
                    color: '#585F65',
                    fontWeight: '400',
                  }}
                >
                  그때그때 빠르게 처리해야 하는 단순·운영성 업무를 놓치지 않기
                  위한 업무 유형입니다
                </Text>
              </div>
            </div>
          </div>
          <div className="form-section">
            <label className="form-label">
              완료 시간 <span style={{ color: 'red' }}>*</span>
            </label>
            <div style={{ width: '100%' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  width: '100%',
                }}
              >
                <DatePicker
                  disabledDate={(current) =>
                    current && current < dayjs().startOf('day')
                  }
                  style={{ flex: 0.4, height: '48px' }}
                  placeholder="날짜를 선택해주세요"
                  suffixIcon={<CalendarFilled />}
                  value={formData.date}
                  onChange={(date) => setFormData({ ...formData, date })}
                  // disabled={true}
                  readOnly={true}
                  format="YYYY-MM-DD"
                  // readOnly={true}
                />
                <Select
                  style={{ width: 80, height: '48px' }}
                  value={formData.hour}
                  onChange={(hour) => setFormData({ ...formData, hour })}
                  // disabled={true}
                  options={hours.map((hour) => ({ label: hour, value: hour }))}
                  popupMatchSelectWidth={false}
                  placeholder="Ex) 09"
                />
                <span>:</span>
                <Select
                  style={{ width: 80, height: '48px' }}
                  value={formData.minute}
                  onChange={(minute) => setFormData({ ...formData, minute })}
                  // disabled={true}
                  options={minutes.map((minute) => ({
                    label: minute,
                    value: minute,
                  }))}
                  popupMatchSelectWidth={false}
                  placeholder="Ex) 30"
                />
              </div>
            </div>
          </div>

          {/* 하위업무 섹션 */}
          <FormSection label="하위업무">
            <div
              style={{
                border: '1px solid #E2EAEF',
                borderRadius: '12px',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
              }}
            >
              {/* 헤더 */}
              <div
                style={{
                  background: '#F6F7FA',
                  padding: '12px 16px',
                  borderBottom: '1px solid #E2EAEF',
                }}
              >
                <div
                  style={{
                    fontSize: '15px',
                    fontWeight: '700',
                    color: '#383E44',
                  }}
                >
                  하위업무 생성하기
                </div>
                <div
                  style={{
                    fontSize: '12px',
                    color: '#8A949E',
                    marginTop: '2px',
                  }}
                >
                  이 테스크에서 체크해야 할 업무를 적어보세요
                </div>
              </div>

              {/* 그리드 영역 */}
              <div
                style={{
                  background: '#FFFFFF',
                  padding: '16px',
                }}
              >
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    columnGap: '40px',
                    rowGap: '12px',
                    width: '100%',
                    paddingRight: '15px',
                    overflow: 'hidden',
                  }}
                >
                  {/* 1. 저장된 항목 리스트 */}
                  {formData?.checkList?.map((item) => (
                    <div
                      key={item.id}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        width: '100%',
                        minWidth: 0,
                      }}
                    >
                      {/* 실제 내용이 담긴 입력 칸 모양의 박스 */}
                      <div
                        style={{
                          flex: 1,
                          display: 'flex',
                          alignItems: 'center',
                          padding: '0 12px',
                          background: '#FFFFFF',
                          borderRadius: '8px',
                          border: `1px solid ${item.isChecked ? '#E2EAEF' : '#383E44'}`,
                          height: '44px',
                          minWidth: 0,
                          overflow: 'hidden',
                        }}
                      >
                        <Checkbox
                          checked={item.isChecked}
                          onChange={() => toggleCheckItem(item.id)}
                          className="custom-circle-checkbox"
                          style={{ marginRight: '10px' }}
                        />
                        {editingId === item.id ? (
                          <Input
                            value={item.title}
                            variant="borderless"
                            autoFocus
                            onBlur={() => setEditingId(null)}
                            onPressEnter={() => setEditingId(null)}
                            onChange={(e) =>
                              handleTitleChange(item.id, e.target.value)
                            }
                            style={{
                              padding: 0,
                              fontSize: 'inherit',
                              fontWeight: 'inherit',
                              color: 'inherit',
                            }}
                          />
                        ) : (
                          <div
                            onClick={() => setEditingId(item.id)}
                            style={{
                              flex: 1,
                              fontSize: '14px',
                              fontWeight: '600',
                              color: item.isChecked ? '#007AFF' : '#191a1c',
                              textDecoration: item.isChecked
                                ? 'line-through'
                                : 'none',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {item.title}
                          </div>
                        )}
                      </div>

                      {/* 오른쪽 삭제 버튼 */}
                      <div
                        onClick={() => removeSubTask(item.id)}
                        style={{
                          flexShrink: 0,
                          width: '24px',
                          height: '24px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          background: '#E2EAEF',
                          borderRadius: '50%',
                          cursor: 'pointer',
                        }}
                      >
                        <span
                          style={{
                            color: '#8A949E',
                            fontSize: '14px',
                            fontWeight: 'bold',
                          }}
                        >
                          ×
                        </span>
                      </div>
                    </div>
                  ))}

                  {/* 2. 현재 입력 중인 세트 */}
                  <div
                    style={{
                      display: 'flex',
                      gap: '8px',
                      alignItems: 'center',
                    }}
                  >
                    <div
                      style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0 12px',
                        background: '#FFFFFF',
                        borderRadius: '8px',
                        border: '1px solid #E2EAEF',
                        height: '44px',
                        overflow: 'hidden',
                      }}
                    >
                      <Input
                        placeholder="하위업무를 적어주세요"
                        value={tempSubTask}
                        variant="borderless"
                        style={{ flex: 1, padding: 0, minWidth: 0 }}
                        onChange={(e) => setTempSubTask(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            // e.nativeEvent.isComposing이 true이면 한글 조합 중이므로 실행하지 않음
                            if (e.nativeEvent.isComposing) return
                            // BoardWorkPopup과 동일하게 e.preventDefault() 없이 처리
                            handleInputSubmit()
                          }
                        }}
                      />
                    </div>
                    <button
                      onClick={handleInputSubmit}
                      disabled={!tempSubTask.trim()}
                      style={{
                        width: '52px',
                        height: '44px',
                        background: '#FFFFFF',
                        border: `1px solid ${tempSubTask.trim() ? '#007AFF' : '#D1D5DB'}`,
                        color: tempSubTask.trim() ? '#007AFF' : '#D1D5DB',
                        borderRadius: '8px',
                        cursor: tempSubTask.trim() ? 'pointer' : 'not-allowed',
                        fontWeight: '600',
                      }}
                    >
                      입력
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </FormSection>
        </div>
        <div className="popup-footer">
          <button
            className="btn-cancel"
            onClick={fastLaneDetail ? handleDelete : resetForm}
          >
            {fastLaneDetail ? '삭제' : '취소'}
          </button>
          <button className="btn-submit" onClick={handleSubmit}>
            {fastLaneDetail ? '수정' : '등록'}
          </button>
        </div>
      </div>
    </AopsCommonModalLayout>
  )
}

export default FastLaneModal
